import { render, staticRenderFns } from "./CurriculumSettingTable.vue?vue&type=template&id=19fad1e0&scoped=true&lang=pug&"
import script from "./CurriculumSettingTable.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSettingTable.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSettingTable.vue?vue&type=style&index=0&id=19fad1e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fad1e0",
  null
  
)

export default component.exports